export { default } from "./TableExpanded";
